function injectStyle (ssrContext) {
  require("!!../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?minimize!../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-67b52c4d\",\"scoped\":true,\"hasInlineConfig\":true}!stylus-loader!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Body.vue")
}
var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Body.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-67b52c4d\",\"hasScoped\":true,\"preserveWhitespace\":false}!../../../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=pug!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Body.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-67b52c4d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/uikit/components/AppModal/components/Body.vue
// module id = aab2d8e5f79d87a20188
// module chunks = 89